export default "__VITE_ASSET__yiGfXqMO__"